import useAuthStore from "@/stores/useAuthStore";

/**
 * EPS-4974 — Alt bayi (sub-merchant) ayrımı.
 *
 * merchant_user.type = STORE olan kullanıcılar alt bayidir: yalnızca kendi yaptıkları
 * satışları görürler. ADMIN/USER ana merchant kullanıcılarıdır ve tüm bayilerin
 * satışlarını görürler. Tip, /merchant-users/info yanıtından gelir ve useAuthStore.user
 * içinde tutulur; asıl kısıtlama backend'de uygulanır, buradaki kontrol sadece arayüzü
 * sadeleştirmek içindir.
 */
export const useMerchantUserType = () => {
  const user = useAuthStore((state) => state.user);

  return {
    type: user?.type,
    sellerCode: user?.sellerCode,
    isStoreUser: user?.type === "STORE",
  };
};

export default useMerchantUserType;
